import { get } from '@shared/adapters/lodash'
import type { InvestmentDetail } from '../../types/investmentDetailTypes'

export const parseInvestmentDetail = (resp: unknown): InvestmentDetail => ({
  propertyOverview: {
    propertyName: get(resp, 'data.propertyOverview.propertyName') ?? '',
    propertyLocation: get(resp, 'data.propertyOverview.propertyLocation') ?? '',
    coverImage: get(resp, 'data.propertyOverview.coverImage') ?? '',
  },
  documents: ((get(resp, 'data.documents') as unknown as unknown[]) ?? []).map((doc) => ({
    id: get(doc, 'id') ?? '',
    documentType: get(doc, 'documentType') ?? '',
    documentTitle: get(doc, 'documentTitle') ?? '',
    filePath: get(doc, 'filePath') ?? '',
  })),
  investmentSummary: {
    investedAmount: Number(get(resp, 'data.investmentSummary.investedAmount') ?? 0),
    currentInvestmentValue: Number(get(resp, 'data.investmentSummary.currentInvestmentValue') ?? 0),
    currency: get(resp, 'data.investmentSummary.currency') ?? 'AED',
    totalReturnsAmount: Number(get(resp, 'data.investmentSummary.totalReturnsAmount') ?? 0),
    totalReturnsPercentage: Number(get(resp, 'data.investmentSummary.totalReturnsPercentage') ?? 0),
    rentalIncomeEarned: Number(get(resp, 'data.investmentSummary.rentalIncomeEarned') ?? 0),
  },
  tokenDetails: {
    tokenName: get(resp, 'data.tokenDetails.tokenName') ?? '',
    tokensHeld: Number(get(resp, 'data.tokenDetails.tokensHeld') ?? 0),
    ownershipPercentage: Number(get(resp, 'data.tokenDetails.ownershipPercentage') ?? 0),
    initialTokenPrice: Number(get(resp, 'data.tokenDetails.initialTokenPrice') ?? 0),
  },
  investmentInfo: {
    investmentDate: get(resp, 'data.investmentInfo.investmentDate') ?? '',
    projectedRoi: Number(get(resp, 'data.investmentInfo.projectedRoi') ?? 0),
  },
})
